import React, { useEffect, useState } from 'react';
import { Menu, X, Globe, Phone } from 'lucide-react';
interface NavbarProps {
  language: 'en' | 'es';
  toggleLanguage: () => void;
}
export function Navbar({
  language,
  toggleLanguage
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    en: 'Services',
    es: 'Servicios',
    href: '#services'
  }, {
    en: 'Why Us',
    es: 'Nosotros',
    href: '#comparison'
  }, {
    en: 'Process',
    es: 'Proceso',
    href: '#process'
  }, {
    en: 'Testimonials',
    es: 'Testimonios',
    href: '#testimonials'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-luxury-bg/95 backdrop-blur-md border-b border-gold-dark/20 py-3' : 'bg-transparent py-5'}`} data-id="element-224">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <div className="flex justify-between items-center" data-id="element-226">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-227">
            <svg viewBox="0 0 100 120" className="w-8 h-10 text-gold-primary fill-current" data-id="element-228">
              <path d="M50 0 L100 20 L100 70 L50 120 L0 70 L0 20 Z" fill="none" stroke="currentColor" strokeWidth="6" data-id="element-229" />
              <text x="50" y="72" textAnchor="middle" fontSize="42" fontFamily="serif" fontWeight="bold" fill="currentColor" data-id="element-230">
                MP
              </text>
            </svg>
            <div className="hidden sm:flex flex-col" data-id="element-231">
              <span className="font-serif text-xl font-bold text-warm-white leading-none tracking-wide" data-id="element-232">
                MAINPOINT
              </span>
              <span className="font-sans text-[0.6rem] font-medium text-gold-light tracking-[0.2em] uppercase mt-1" data-id="element-233">
                Multiservices
              </span>
            </div>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-234">
            {navLinks.map(link => <a key={link.en} href={link.href} className="text-sm font-medium text-warm-gray hover:text-gold-light transition-colors tracking-wide uppercase" data-id="element-235">
                {language === 'en' ? link.en : link.es}
              </a>)}
          </div>

          {/* Actions */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-236">
            <button onClick={toggleLanguage} className="flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-warm-gray hover:text-gold-light border border-gold-dark/30 hover:border-gold-primary/50 rounded-full transition-all duration-300 tracking-wider" data-id="element-237">
              <span className="text-base leading-none" data-id="element-238">
                {language === 'en' ? '🇺🇸' : '🇪🇸'}
              </span>
              <span data-id="element-239">{language === 'en' ? 'EN' : 'ES'}</span>
            </button>
            <a href="#contact" className="flex items-center gap-2 px-5 py-2.5 bg-brand-red text-white text-sm font-bold uppercase tracking-wider rounded hover:bg-red-700 hover:shadow-red-glow transition-all duration-300" data-id="element-240">
              <Phone className="w-4 h-4" data-id="element-241" />
              {language === 'en' ? 'Contact Us' : 'Contáctanos'}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-warm-white hover:text-gold-light" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-242">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-243" /> : <Menu className="w-6 h-6" data-id="element-244" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-luxury-card border-b border-gold-dark/20 py-4 px-4 shadow-2xl" data-id="element-245">
          <div className="flex flex-col space-y-4" data-id="element-246">
            {navLinks.map(link => <a key={link.en} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-medium text-warm-white hover:text-gold-light transition-colors tracking-wide uppercase py-2 border-b border-gold-dark/10" data-id="element-247">
                {language === 'en' ? link.en : link.es}
              </a>)}
            <div className="flex items-center justify-between pt-4" data-id="element-248">
              <button onClick={toggleLanguage} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gold-light border border-gold-dark/30 rounded-full uppercase tracking-widest" data-id="element-249">
                <span className="text-base leading-none" data-id="element-250">
                  {language === 'en' ? '🇺🇸' : '🇪🇸'}
                </span>
                <span data-id="element-251">{language === 'en' ? 'EN' : 'ES'}</span>
              </button>
            </div>
            <a href="#contact" className="flex items-center justify-center gap-2 w-full px-5 py-3 bg-brand-red text-white text-sm font-bold uppercase tracking-wider rounded mt-4" data-id="element-252">
              <Phone className="w-4 h-4" data-id="element-253" />
              {language === 'en' ? 'Contact Us' : 'Contáctanos'}
            </a>
          </div>
        </div>}
    </nav>;
}